import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { Icon, useHover, useLanguage } from "@/lib/main";
import { CSSProperties } from "react";

export default function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const { isFocused, setIsFocused, onFocus, onBlur } = useFocus();
  const { isHovered, setIsHovered, onMouseEnter, onMouseLeave } = useHover();

  const handleClick = () => {
    setIsFocused(false);
    setIsHovered(false);
    if (language === "ar") setLanguage("en");
    else setLanguage("ar");
  };

  const buttonStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",

    border: "none",
    background: "transparent",

    // * increases clickable area
    height: "3rem",
  };

  const spanStyle: CSSProperties = {
    color: "var(--color-text-secondary)",
    fontSize: "var(--font-size-sm)",
    fontWeight: 400,
  };

  const iconContainerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: isHovered
      ? "var(--color-icon-hover)"
      : isFocused
        ? "var(--color-icon-focus)"
        : "transparent",
    borderRadius: "50%",
    padding: "0.5rem",
  };

  return (
    <button
      aria-label={
        language === "ar"
          ? "تغيير اللغة بين الإنجليزية والعربية"
          : "Toggle between English and Arabic language"
      }
      onClick={handleClick}
      style={buttonStyle}
      title={
        language === "en"
          ? "Change language to Arabic"
          : "تغيير اللغة إلى الإنجليزية"
      }
    >
      <span
        className={
          language === "en" ? "arabic-font-override" : "english-font-override"
        }
        style={spanStyle}
      >
        {language === "en" ? "العربية" : "EN"}
      </span>

      <div
        onBlur={onBlur}
        onFocus={onFocus}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={iconContainerStyle}
      >
        <Icon name="globe" color="secondary" size={"lg"} />
      </div>
    </button>
  );
}
